module.exports = __webpack_public_path__ + "img/home_marker.089ce116.png";